<template>
  <div>
    <v-card>
      <div class="pt-2">
        <v-card flat>
          <v-row class="d-flex justify-space-between padding-bottom">
            <div>
              <v-btn
                  depressed
                  color="primary"
                  v-on:click="back()">
                返回
              </v-btn>
            </div>
          </v-row>
        </v-card>
      </div>
    </v-card>
    <v-form v-model="data">
      <v-card class="ma-2" elevation="0">
        <v-card-title>基础信息</v-card-title>
        <v-card-text>
          <v-row no-gutters justify="space-around">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>任务编号:</label><label>{{ data.id }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>任务名称:</label><label>{{ data.taskName }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>巡检日期:</label><label>{{ data.taskStartDate }}~{{ data.taskEndDate }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-around" class="mt-3">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>巡检时段:</label><label>{{ data.itemName }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>巡检结束时间:</label><label>{{ data.finishTime }}</label>
            </v-col>
            <v-col cols="12" sm="3" style="text-align: left">
              <label>任务发布时间:</label><label>{{ data.createTime }}</label>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-around" class="mt-3">
            <v-col cols="12" sm="3" style="text-align: left">
              <label>状态:</label><label>{{ _jungleStatus(data.status) }}</label>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.detailList">
        <v-card-title>巡检明细</v-card-title>
        <v-item-group>
          <v-container>
            <v-row>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5">
                      <div>已检查点位</div>
                      <p class="text-h4 text--primary">
                        {{ data.checkedAmount }}/{{ data.totalCheckAmount }}
                      </p></v-card-text>
                  </v-card>
                </v-item>
              </v-col>
              <v-col cols="12" md="2">
                <v-item>
                  <v-card class="d-flex align-center" height="75">
                    <v-card-text class="mt-5">
                      <div>待销项</div>
                      <p class="text-h4 text--primary">
                        {{ data.writeOffAmount }}/{{ data.totalWriteOffAmount }}
                      </p></v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
        <v-row class="d-flex justify-space-between padding-bottom">
          <div>
            <v-btn
                depressed
                color="primary"
                class="margin-right"
                @click="handleExportDetails"
                :disabled="!_hasButtonPermission('导出')">
              导出
            </v-btn>
            <v-btn
                depressed
                color="primary"
                @click="handleExportPics"
                :disabled="!_hasButtonPermission('导出')">
              导出图片
            </v-btn>
          </div>
        </v-row>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center" width="100">点位名称</th>
                <th class="text-center" width="100">点位编号</th>
                <th class="text-center" width="100">位置</th>
                <th class="text-center" width="100">巡检项</th>
                <th class="text-center" width="100">检查情况</th>
                <th class="text-center" width="100">有无异常</th>
                <th class="text-center" width="100">异常说明</th>
                <th class="text-center" width="100">异常解决状态</th>
                <th class="text-center" width="100">异常解决说明</th>
                <th class="text-center" width="100">异常解决时间</th>
                <th class="text-center" width="100">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in data.detailList" :key="i">
                <td class="text-center">{{ item.pointName }}</td>
                <td class="text-center">{{ item.pointCode }}</td>
                <td class="text-center">{{ item.location }}</td>
                <td class="text-center">{{ item.itemName }}</td>
                <td class="text-center">{{ _jungleCheckStatus(item.status) }}</td>
                <td class="text-center">{{ _jungleHasProblem(item.hasProblem) }}</td>
                <td class="text-center">{{ item.problemDesc }}</td>
                <td class="text-center">{{ _jungleHasProblem(item.fixedStatus) }}</td>
                <td class="text-center">{{ item.problemFixedDesc }}</td>
                <td class="text-center">{{ item.problemFixedTime }}</td>
                <td class="text-center">
                  <v-btn v-if="item.orderPointId" text color="primary" block small
                         @click="viewSpotPictures(item.orderPointId)">现场图片
                  </v-btn>
                  <v-btn v-if="item.fixedStatus==3" text color="primary" block small @click="clickWrite(item)">销项
                  </v-btn>
				  <v-btn v-if="item.fixedStatus==4 && data.pointType == 2" text color="primary" block small @click="againWrite(item)">重新销项
				  </v-btn>
                  <v-btn v-if="item.problemPics" text color="primary" block small @click="viewPictures(item)">查看图片
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <v-card class="ma-2" elevation="0" v-if="data.transferList">
        <v-card-title>转单记录</v-card-title>
        <v-card-text>
          <v-simple-table dense class="mb-2">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center" width="100">发起人</th>
                <th class="text-center" width="100">接收人</th>
                <th class="text-center" width="100">转单理由</th>
                <th class="text-center" width="200">审批人</th>
                <th class="text-center" width="200">审批结果</th>
                <th class="text-center" width="200">发起时间</th>
                <th class="text-center" width="200">审批时间</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in data.transferList" :key="i">
                <td class="text-center">{{ item.createBy }}</td>
                <td class="text-center">{{ item.receiverName }}</td>
                <td class="text-center">{{ item.transferReason }}</td>
                <td class="text-center">{{ item.auditName }}</td>
                <td class="text-center">{{ _jungleAuditStatus(item.status) }}</td>
                <td class="text-center">{{ item.createTime }}</td>
                <td class="text-center">{{ item.auditTime }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-form>
    <!--现场图片弹窗-->
    <v-dialog
        persistent
        v-model="spotDialogShow"
        width="700">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          现场图片
        </v-card-title>
        <v-card-text>
          <template v-if="spotImgs">
            <v-row>
              <v-col
                  v-for="(item,index) in spotImgs"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3">
                <img
                    :src="item"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    preview="0"
                    width="139"
                    height="139"
                    style="object-fit: cover">
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="closeSpotImgDialog()"
          >
            关闭
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--查看图片弹窗-->
    <v-dialog
        persistent
        v-model="dialogShow"
        width="700">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          查看图片
        </v-card-title>
        <v-card-text>
          <template v-if="questionImgs">
            <v-row>
              <p class="text-h5 text--primary">
                问题图片
              </p>
            </v-row>
            <v-row>
              <v-col
                  v-for="(item,index) in questionImgs"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3">
                <img
                    :src="item"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    preview="1"
                    width="139"
                    height="139"
                    style="object-fit: cover">
              </v-col>
            </v-row>
          </template>
          <template v-if="writeOffImgs">
            <v-row>
              <p class="text-h5 text--primary">
                销项图片
              </p>
            </v-row>
            <v-row>
              <v-col
                  v-for="(item,index) in writeOffImgs"
                  :key="index"
                  class="d-flex child-flex"
                  cols="3">
                <img
                    :src="item"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    preview="2"
                    width="139"
                    height="139"
                    style="object-fit: cover">
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="closeImgDialog()"
          >
            关闭
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--销项弹窗-->
    <v-dialog
        v-model="writeOffDialogShow"
        persistent
        max-width="700px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">销项</span>
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-form v-model="writeOffValid">
              <v-row no-gutters>
                <v-col cols="12" sm="2" style="text-align: left">
                  <label>销项说明：</label>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                      v-model="problemFixedDesc"
                      single-line
                      outlined
                      dense
                      required
                      :rules="rules"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row no-gutters style="margin-top: 12px;">
                <v-col cols="12" sm="2" style="text-align: left">
                  <label>销项图片：</label>
                </v-col>
              </v-row>
              <v-row no-gutters style="margin-top: 12px;">
                <v-col cols="12" sm="12" style="text-align: left">
                  <el-upload
                      ref="specUploadPic"
                      :action="uploadUrl"
                      :headers="headers"
                      name="file"
                      :limit="4"
                      :data="uploadData"
                      list-type="picture-card"
                      accept="jpeg, jpg, png"
                      :file-list="uploadPics"
                      :on-remove="handleRemove"
                      :on-success="handleAvatarSuccess"
                      :on-exceed="handleExceed"
                      :before-upload="beforeAvatarUpload"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="closeWriteOff"
          >
            取消
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              :disabled="btnDisabled"
              @click="sureWriteOff">
            销项
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import xjOrderApi from "@/api/pd/inspection/XjOrderApi";
import downloadUtil from "@/util/downloadUtil.js";
import Auth from "@/util/auth";

export default {
  props: {
    orderId: [Number, String],
    buttonPriviledgeList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      // 上传的headers
      headers: {
        "HC-SMP-Authorization": Auth.getAccessToken()
      },
      loading: false,
      data: {},
      btnDisabled: false,
      dialogShow: false,
      spotDialogShow: false,
      spotImgs: null,
      questionImgs: null,
      writeOffImgs: null,
      questionId: null,
      writeOffDialogShow: false,
      writeOffValid: false,
      rules: [(v) => !!v || '必填'],
      problemFixedDesc: "", // 销项原因
      uploadPics: [],
      uploadUrl: null, // 固定上传图片路径
      auditDialog: false,
      uploadData: {
        path: ''
      }
    };
  },
  mounted() {
    this.getDataFromApi();
    this.uploadUrl = xjOrderApi.IMG_UPLOAD_URL;
    this.uploadData.path = '/wgManager/' + this._getTodayDateStr()
  },
  methods: {
    back() {
      this.$emit("back")
    },
    getDataFromApi() {
      this.loading = true;
      let me = this;
      xjOrderApi.detailXJOrder({
        orderId: this.orderId
      }).then(resp => {
        xjOrderApi.handleResponse(resp, me, function (data) {
          me.loading = false;
          me.data = data;
        }, function () {
          me.loading = false;
        })
      }).catch(error => {
        xjOrderApi.handleNetworkError(error, me, function () {
          me.loading = false;
        })
      })
    },
    // 删除图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 上传前校验
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 < 500;
      if (!isLt2M) {
        this.$dialog.error({
          title: '错误',
          text: '上传图片大小不能超过 500KB!'
        })
      }
      return isLt2M;
    },
    // 超出上传限制
    handleExceed() {
      this.$dialog.error({
        title: '错误',
        text: '做多上传4张图片'
      })
    },
    // 上传成功
    handleAvatarSuccess(res, file, fileList) {
      console.log("file", file);
      console.log("fileList", fileList);
      file.url = res.data;
    },
    _hasButtonPermission(name) {
      let buttonPriviledgeList = this.buttonPriviledgeList
      let hasButton = false
      for (let i = 0; i < buttonPriviledgeList.length; i++) {
        if (buttonPriviledgeList[i].name == name) {
          if (buttonPriviledgeList[i].hasPriviledge == 'Y') {
            return true
          } else {
            return false
          }
        }
      }
      return false
    },
    // 点击查看图片
    viewPictures(item) {
      // 处理问题图片
      let hasImg = false
      if (item.problemPics) {
        hasImg = true
        this.questionImgs = item.problemPics.split(",")
      }
      if (item.fixedPics) {
        hasImg = true
        this.writeOffImgs = item.fixedPics.split(",")
      }
      if (!hasImg) {
        this.$dialog.error({
          title: '错误',
          text: '该检查项没有图片展示'
        })
        return
      }
      this.dialogShow = true
    },
    // 关闭查看图片
    closeImgDialog() {
      this.questionImgs = null
      this.writeOffImgs = null
      this.dialogShow = false
    },
    // 点击查看现场图片
    viewSpotPictures(orderPointId) {
      let me = this
      xjOrderApi.selectXJPointPic({
        orderPointId: orderPointId
      }).then(resp => {
        xjOrderApi.handleResponse(resp, me, function (data) {
          if (!resp.data || !resp.data.data) {
            this.$dialog.error({
              title: '错误',
              text: '该检查点位没有图片展示'
            })
          } else {
            me.spotDialogShow = true
            me.spotImgs = resp.data.data.split(",");
            me.$previewRefresh();
          }
        }, function () {
        })
      }).catch(error => {
        xjOrderApi.handleNetworkError(error, me, function () {
        })
      })

    },
    // 关闭查看图片
    closeSpotImgDialog() {
      this.spotImgs = null
      this.spotDialogShow = false
    },
    // 点击销项
    clickWrite(item) {
      if (item.fixedStatus != 3) {
        this.$dialog.error({
          title: '错误',
          text: '待销项状态才能销项'
        })
        return
      }
      this.writeOffDialogShow = true
      this.questionId = item.id
    },
	// 重新销项
	againWrite(item) {
	  let me = this
	  if (item.fixedStatus != 4 && this.data.pointType == 2) {
		this.$dialog.error({
		  title: '错误',
		  text: '销项完成状态才能重新销项'
		})
		return
	  }
	  xjOrderApi.againWrite({
	    id: item.id
	  }).then(resp => {
		console.log(resp)  
	    xjOrderApi.handleResponse(resp, me, function (data) {
	      if (!resp.data || resp.data.code != 200) {
	        me.$dialog.error({
	          title: '错误',
	          text: resp.data.msg
	        })
	      } else {
	        me.$dialog.info({
	          title: '提示',
	          text: '操作成功'
	        })
			me.back()
	      }
	    }, function () {
	    })
	  }).catch(error => {
	    xjOrderApi.handleNetworkError(error, me, function () {
	    })
	  })
	},
    // 关闭销项弹窗
    closeWriteOff() {
      this.writeOffDialogShow = false
      this.questionId = null
      this.problemFixedDesc = ""
    },
    // 确认销项
    sureWriteOff() {
      if (!this.writeOffValid) {
        this.$dialog.error({
          title: '错误',
          text: '解决说明必填'
        })
        return
      }
      let questionId = this.questionId
      let problemFixedDesc = this.problemFixedDesc
      let fixedPics = this.$refs.specUploadPic.uploadFiles
          .map(item => item.url)
          .join(",")
      let me = this
      me.btnDisabled = true
      xjOrderApi.writeOffXjDetail({
        id: questionId,
        problemFixedDesc: problemFixedDesc,
        fixedPics: fixedPics
      }).then(resp => {
        xjOrderApi.handleResponse(resp, me, function (data) {
          me.$dialog.info({
            text: '销项成功',
            title: '操作成功'
          })
          me.closeWriteOff()
          me.btnDisabled = false
          me.getDataFromApi()
        }, () => {
          me.btnDisabled = false
        })
      }).catch(error => {
        xjOrderApi.handleNetworkError(error, me, function () {
          me.btnDisabled = false
        })
      })
    },
    async handleExportDetails() {
      let me = this;
      let res = await xjOrderApi.exportXjOrderDetails({
        orderId: me.orderId
      });
      downloadUtil.downloadByBlob({res: res.data, fileName: "巡检单明细导出数据.xlsx"});
    },
    async handleExportPics() {
      let me = this;
      let res = await xjOrderApi.exportXjOrderPics({
        orderId: me.orderId
      });
      downloadUtil.downloadByBlob({res: res.data, fileName: "巡检单图片导出数据.xlsx"});
    },
    _jungleStatus(status) {
      if (status == 1) {
        return "待接单"
      } else if (status == 2) {
        return "待指派"
      } else if (status == 3) {
        return "待执行"
      } else if (status == 4) {
        return "待审批"
      } else if (status == 5) {
        return "已完成"
      } else if (status == 6) {
        return "已过期"
      } else {
        return "经理待审批"
      }
    },
    _jungleAuditStatus(status) {
      if (status == 1) {
        return "待审批"
      } else if (status == 2) {
        return "审批成功"
      } else {
        return "审批失败"
      }
    },
    _jungleHasProblem(status) {
      if (status == 1) {
        return "正常"
      } else if (status == 2) {
        return "异常"
      } else {
        return null;
      }
    },
    _jungleCheckStatus(status) {
      if (status == 1) {
        return "未检查"
      } else if (status == 2) {
        return "已检查"
      } else if (status == 3) {
        return "待销项"
      } else if (status == 4) {
        return "已销项"
      } else {
        return null
      }
    },
    _getTodayDateStr() {
      var today = new Date();
      var month = today.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      return today.getFullYear() + '/' + month + '/' + day;
    }
  }
};
</script>
<style scoped>
.container {
  padding: 0;
}

.row {
  margin: 0;
}

.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}

.padding-top {
  padding-top: 30px;
}

.margin-right {
  margin-right: 12px;
}

.v-application p {
  margin-bottom: 0;
}
</style>